// GSAP动画
window.addEventListener('DOMContentLoaded', () => {
    // ug-retractable-video 吸顶 + 居中铺满动画
    gsap.registerPlugin(ScrollTrigger);
      function getViewportWidth() {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    function pageBanner() {
        const bannerImg = document.querySelector('.ug-retractable-banner-product-image img');

        if (bannerImg.complete) {
            animateHeroImage();
        } else {
            bannerImg.addEventListener('load', animateHeroImage);
        }

        function animateHeroImage() {
            gsap.to(bannerImg, {
                scale: 1,
                duration: 1.2,
                ease: "power2.out"
            });
        }
    }
    function navBar() {
        // 1. 吸顶出现
        const nav = document.querySelector('.ug-retractable-nav-container-pc');
        const navMol = document.querySelector('.ug-retractable-nav-container-mol');
        const scroll = document.querySelector('.ug-retractable-scroll-control');
        const triggerY = document.getElementById('overview').offsetTop - 1;// 80为导航高度

        window.addEventListener('scroll', function () {
            if (window.scrollY >= triggerY) {
                nav.classList.add('visible');
                navMol.classList.add('visible');
                scroll.classList.add('show');
            } else {
                nav.classList.remove('visible');
                navMol.classList.remove('visible');
                scroll.classList.remove('show');
            }
            highlightNav();
        });

        // 2. 高亮锚点
        // 1. 获取所有可见的导航链接（只高亮当前端口的nav）
        function getVisibleNavLinks() {
            // 只选当前可见的导航（PC或Mobile）
            return Array.from(document.querySelectorAll('.ug-retractable-nav-link')).filter(link => {
                // 检查父级nav是否可见
                const parent = link.closest('.ug-retractable-nav-container, .ug-retractable-scroll-control');
                return parent && window.getComputedStyle(parent).display !== 'none';
            });
        }

        function getNavOffset(link) {
            // 获取当前可见nav的高度（吸顶时用）
            const nav = link.closest('.ug-retractable-nav-container, .ug-retractable-scroll-control');
            return nav ? nav.offsetHeight : 0;
        }

        function highlightNav() {
            const navLinks = getVisibleNavLinks();
            let scrollPos = window.scrollY + (navLinks[0] ? getNavOffset(navLinks[0]) : 0) + 10;
            let activeLink = null;

            navLinks.forEach(link => {
                const id = link.getAttribute('href').replace('#', '');
                const target = document.getElementById(id);
                if (target) {
                    const rect = target.getBoundingClientRect();
                    const secTop = rect.top + window.scrollY;
                    if (scrollPos >= secTop) {
                        activeLink = link;
                    }
                }
            });

            navLinks.forEach(link => {
                link.classList.toggle('active', link === activeLink);
            });
        }

        window.addEventListener('scroll', highlightNav);
        window.addEventListener('resize', highlightNav);
        highlightNav();

        // 2. 平滑滚动
        getVisibleNavLinks().forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const id = this.getAttribute('href').replace('#', '');
                const target = document.getElementById(id);
                if (target) {
                    const offset = getNavOffset(this);
                    window.scrollTo({
                        top: target.getBoundingClientRect().top + window.scrollY - offset,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }
    function retractable_video() {
        const retractableVideo = document.querySelector('.ug-retractable-video-bg');
        // 1. 视频进入/离开视口时播放/暂停
        ScrollTrigger.create({
            trigger: ".ug-retractable-video",
            start: "top bottom",
            end: "bottom top",
            onEnter: () => retractableVideo.play(),
            onEnterBack: () => retractableVideo.play(),
            onLeave: () => retractableVideo.pause(),
            onLeaveBack: () => retractableVideo.pause(),
        });
        gsap.to('.ug-retractable-video-bg', {
            opacity: 1,
            ease: 'power1.inOut',
            scrollTrigger: {
                trigger: '.ug-retractable-video-bg',
                start: 'top 100%',
                end: "top 60%",
                scrub: true
            }
        });
        gsap.to('.ug-retractable-video-bg', {
            width: "100%",
            height: "100%",
            ease: 'power1.inOut',
            scrollTrigger: {
                trigger: '.ug-retractable-video-bg',
                start: 'top 60%',
                end: "top top",
                scrub: true
            }
        });

        // 2. 吸顶并播放遮罩动画
        const pinTl = gsap.timeline({
            scrollTrigger: {
                trigger: ".ug-retractable-video",
                pin: true,
                scrub: true,
                start: "top top",
                end: "+=150%", // 增加动画时长
            }
        });

        pinTl.to("#ugRetractableVideoMask", {
            opacity: 1,
            ease: "power1.inOut"
        })
            // 最后阶段：显示播放按钮
            .to("#ugRetractablePlayButton", {
                opacity: 1,
                visibility: 'visible'
            });
    }
    function nexodelineupSwiperFn() {
        if (getViewportWidth() >= 768) {
          const UserReview_slider = new Swiper('.ug-retractable-lineup-swiper', {
                direction: 'horizontal',
                threshold: 30, // 超过30px才算做滑动
                initialSlide: 0,
                slidesPerView: "auto",
                spaceBetween: 20
            });
        } else {
          const UserReview_slider = new Swiper('.ug-retractable-lineup-swiper', {
                direction: 'horizontal',
                threshold: 30, // 超过30px才算做滑动
                initialSlide: 0,
                slidesPerView: 1, // 屏幕小于767px时，每个视图显示1个slide
                spaceBetween: 16,
                observer: true,
                observeParents: true,
                grid: {
                    rows: 4, // 屏幕小于767px时启用grid布局，设置为2行
                },
                pagination: {
                    el: ".ug-retractable-lineup-swiper .swiper-pagination",
                    clickable: true,
                }
            });
          // 获取所有触发按钮
          const buttons = document.querySelectorAll('.popup_button');
          
          // 按钮点击事件
        buttons.forEach(button => {
          button.addEventListener('click', function(e) {
            e.preventDefault();
            const popup = this.closest('div').querySelector('.ug_code_popup');
            
            if (popup) {
              // 关闭其他弹窗
              document.querySelectorAll('.ug_code_popup').forEach(p => {
                if (p !== popup) p.style.display = 'none';
              });
              
              // 显示当前弹窗
              popup.style.display = 'block';
            }
          });
        });
        
        // 事件委托处理关闭按钮（兼容动态内容）
        document.addEventListener('click', function(e) {
          if (e.target.closest('.ug_code_popup svg')) {
            e.target.closest('.ug_code_popup').style.display = 'none';
          }
        });
        
          document.querySelectorAll('.popup_button').forEach(link => {
            link.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
              }
            });
          });
        }
    }
    function features() {
        // ug-retractable-features 滚动渐变高亮动画（修复bug版）
        gsap.utils.toArray('.ug-retractable-features-row').forEach(row => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: row,
                    start: "top 80%", // 动画在元素底部触碰到视口顶部时开始
                    end: "top 50%",   // 动画在元素顶部触碰到视口底部时结束
                    scrub: 1,
                }
            });

            // 时间线包含两个阶段：淡入到中心，然后从中心淡出
            tl.to(row, { opacity: 1, y: 0, ease: "power2.out" });
        });
    }
    function sequence() {
        // --- ug-retractable-hero-sequence Animation (Optimized & Prefixed) ---

        // 1. 基本设置和图片预加载
        const canvas = document.getElementById("ug-retractable-hero-sequence-canvas");
        const context = canvas.getContext("2d");
        const frameCount = 159; // 159帧
        const images = [];
        const imageSequence = { frame: 0 };
        const getCurrentFrame = (index) => `https://cdn.shopify.com/s/files/1/0257/5246/9566/files/ug_retractable_${(index).toString().padStart(3, '0')}.webp`;
        for (let i = 0; i < frameCount; i++) {
            const img = new Image();
            img.src = getCurrentFrame(i);
            images.push(img);
        }
        // 始终显示第一帧为封面
        function renderFirstFrame() {
            imageSequence.frame = 0;
            renderCanvas();
        }
        function renderCanvas() {
            if (images[imageSequence.frame] && images[imageSequence.frame].complete) {
                const img = images[imageSequence.frame];
                const dpr = window.devicePixelRatio || 1;
                const scaledCanvasWidth = canvas.width / dpr;
                const scaledCanvasHeight = canvas.height / dpr;
                const imgAspectRatio = img.width / img.height;
                const canvasAspectRatio = scaledCanvasWidth / scaledCanvasHeight;
                let renderWidth, renderHeight, x, y;
                if (imgAspectRatio > canvasAspectRatio) {
                    renderHeight = scaledCanvasHeight;
                    renderWidth = renderHeight * imgAspectRatio;
                } else {
                    renderWidth = scaledCanvasWidth;
                    renderHeight = renderWidth / imgAspectRatio;
                }
                x = (scaledCanvasWidth - renderWidth) / 2;
                y = (scaledCanvasHeight - renderHeight) / 2;
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(img, x, y, renderWidth, renderHeight);
            }
        }
        function resizeCanvas() {
            const viewport = document.querySelector(".ug-retractable-hero-sequence-viewport");
            const dpr = window.devicePixelRatio || 1;
            // 画布宽度初始1280，后期动画铺满
            let width = 1280, height = 720;
            if (viewport && viewport.offsetWidth > 0 && viewport.offsetHeight > 0) {
                width = viewport.offsetWidth;
                height = viewport.offsetHeight;
            }
            canvas.width = width * dpr;
            canvas.height = height * dpr;
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.scale(dpr, dpr);
            renderCanvas();
        }
        images[0].onload = function () {
            resizeCanvas();
            renderFirstFrame();
        };
        window.addEventListener('resize', function () {
            resizeCanvas();
            renderFirstFrame();
        });

        // 动画主时间线
        function setHeroSectionHeight() {
            const viewport = document.querySelector(".ug-retractable-hero-sequence-viewport");
            const section = document.querySelector(".ug-retractable-hero-sequence");
            if (viewport && section) {
                section.style.height = viewport.offsetHeight + 'px';
            }
        }
        setHeroSectionHeight();
        window.addEventListener('resize', setHeroSectionHeight);

        const section = document.querySelector('.ug-retractable-hero-sequence');
        const viewport = document.querySelector('.ug-retractable-hero-sequence-viewport');
        // 1. section初始化全屏白色，viewport宽1280居中，swiper隐藏
        section.style.maxWidth = '100vw';
        section.style.margin = '0 auto';
        section.style.minHeight = '100vh';
        viewport.style.maxWidth = '1280px';
        viewport.style.width = '100%';
        viewport.style.margin = '0 auto';
        const container = document.querySelector('.ug-retractable-hero-sequence-container');
        gsap.to(viewport, {
            maxWidth: '100vw',
            width: '100vw',
            height: '100vh',
            margin: 0,
            ease: 'power1.inOut',
            scrollTrigger: {
                trigger: viewport,
                start: 'top 80%',
                end: "top top",
                scrub: true
            }
        });
        const heroTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                pin: true,
                scrub: 1.2,
                start: "top top",
                end: () => "+=" + viewport.offsetHeight * 1.5,
                onUpdate: (self) => {
                    if (self.progress === 0) renderFirstFrame();
                },
            }
        });
        // 2. 画布从1280到全屏扩展，确保maxWidth和width都为100vw
        // heroTimeline.to(viewport, {
        //   maxWidth: '100vw',
        //   width: '100vw',
        //   height: '100vh',
        //   margin: 0,
        //   ease: 'power1.inOut',
        //   onUpdate: resizeCanvas
        // }, "+=0.1");

        // 3. 画布铺满后再播放帧动画（区间再拉长一倍，滚动更慢）
        heroTimeline.to(imageSequence, {
            frame: frameCount - 1,
            duration: 40,
            snap: "frame",
            ease: "none",
            onUpdate: renderCanvas
        }, "+=0.8"); // 区间更长更慢
        // 4. 下滑出现黑色背景+渐变遮罩+文案+对比板块整体浮现
        heroTimeline.to(".ug-retractable-hero-gradient-mask", { opacity: 1, y: 0, duration: 2, ease: 'power1.inOut' })
        if (getViewportWidth() > 768) {
            // 5. 轮播图文案后再渐现
            const swiperBlock = document.querySelector('.ug-retractable-hero-sequence-swiper');
            swiperBlock.style.opacity = '0';
            swiperBlock.style.transform = 'translateY(40px)';
            const t_sequence = document.querySelector('.ug-retractable-hero-sequence-content-wrapper');
            const herosequence = gsap.timeline({
                scrollTrigger: {
                    trigger: t_sequence,
                    scrub: true,
                    start: "top 80%",
                }
            });
            herosequence.to(".ug-retractable-hero-title-wrapper", { opacity: 1, y: 0, ease: "power2.out" })
            herosequence.to(swiperBlock, { opacity: 1, y: 0, duration: 0.5, ease: "power2.out" })
            herosequence.to(t_sequence, { duration: 1, borderRadius: 20, scale: 0.6, ease: 'power1.inOut' })
            // 6. 取消最后一步的收缩和变色动画，动画到此结束
        }


        // 3. Swiper初始化
        const HERO_AUTOPLAY = 4000;
        const heroSwiper = new Swiper('.ug-retractable-hero-sequence-swiper', {
            slidesPerView: 2,
            spaceBetween: 20,
            loop: false, // 关闭loop避免切换bug
            autoplay: {
                delay: HERO_AUTOPLAY,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.ug-retractable-hero-sequence-swiper .swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}"><span class="swiper-pagination-progress"><span class="swiper-pagination-progress-bar"></span></span></span>`;
                }
            },
        });
        // 进度条动画
        function startHeroProgressBar() {
            const bullets = document.querySelectorAll('.ug-retractable-hero-sequence-swiper .swiper-pagination-bullet');
            bullets.forEach((bullet, idx) => {
                const bar = bullet.querySelector('.swiper-pagination-progress-bar');
                bar.style.transition = 'none';
                bar.style.transform = 'scaleX(0)';
                if (idx === heroSwiper.realIndex) {
                    setTimeout(() => {
                        bar.style.transition = `transform ${HERO_AUTOPLAY}ms linear`;
                        bar.style.transform = 'scaleX(1)';
                    }, 30);
                }
            });
        }
        heroSwiper.on('slideChange', startHeroProgressBar);
        heroSwiper.on('autoplay', startHeroProgressBar);
        document.addEventListener('DOMContentLoaded', startHeroProgressBar);

        // Swiper初始化
        const swiper = new Swiper('.ug-hero-swiper-right', {
            slidesPerView: 1,
            effect: 'fade',
            speed: 600,
            allowTouchMove: false,
            loop: false,
            fadeEffect: {
                crossFade: true,
            },
            pagination: {
                el: '.ug-hero-swiper-right .swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"></span>';
                }
            }
        });

        // 手风琴交互
        var accordionItems = document.querySelectorAll('.ug-hero-accordion-item');
        var progressBars = document.querySelectorAll('.ug-hero-accordion-progress-bar');
        const AUTOPLAY_DURATION = 5000; // ms
        const CIRCLE_LENGTH = 2 * Math.PI * 12; // r=12
        let progressTimer = null;

        function resetAllProgressBars() {
            progressBars.forEach(bar => {
                bar.style.transition = 'none';
                bar.setAttribute('stroke-dashoffset', CIRCLE_LENGTH);
                bar.style.opacity = '0.5';
                bar.style.transform = 'scale(0.7)';
            });
        }

        function animateProgressBar(index) {
            resetAllProgressBars();
            const bar = progressBars[index];
            bar.style.transition = 'none';
            bar.setAttribute('stroke-dashoffset', CIRCLE_LENGTH);
            bar.style.opacity = '0';
            bar.style.transform = 'scale(0.7)';
            void bar.offsetWidth;
            bar.style.transition = `opacity 0.2s, transform 0.3s`;
            bar.style.opacity = '1';
            bar.style.transform = 'scale(1)';
            setTimeout(() => {
                bar.style.transition = `stroke-dashoffset ${AUTOPLAY_DURATION}ms linear`;
                bar.setAttribute('stroke-dashoffset', 0);
                if (progressTimer) clearTimeout(progressTimer);
                progressTimer = setTimeout(() => {
                    let next = (index + 1) % accordionItems.length;
                    swiper.slideTo(next);
                    setAccordionActive(next);
                    animateProgressBar(next);
                }, AUTOPLAY_DURATION);
            }, 300);
        }

        function setAccordionActive(index) {
            accordionItems.forEach((item, i) => {
                item.classList.toggle('ug-hero-accordion-item--active', i === index);
                item.querySelector('.ug-hero-accordion-arrow').classList.toggle('ug-hero-accordion-arrow--up', i === index);
                // item.querySelector('.ug-hero-accordion-arrow').textContent = i === index ? '▲' : '▼';
                const content = item.querySelector('.ug-hero-accordion-content');
                if (content) {
                    content.style.display = i === index ? 'block' : 'none';
                }
            });
            animateProgressBar(index);
        }

        accordionItems.forEach((item, i) => {
            item.addEventListener('click', () => {
                swiper.slideTo(i);
                setAccordionActive(i);
            });
        });

        swiper.on('slideChange', function () {
            setAccordionActive(swiper.activeIndex);
        });

        // 初始化
        setAccordionActive(0);
        const sequence_video = document.querySelector('.sequence_video');
        // 1. 视频进入/离开视口时播放/暂停
        ScrollTrigger.create({
            trigger: ".ug-retractable-sequence",
            start: "top bottom",
            end: "bottom top",
            onEnter: () => sequence_video.play(),
            onEnterBack: () => sequence_video.play(),
            onLeave: () => sequence_video.pause(),
            onLeaveBack: () => sequence_video.pause(),
        });
    }
    function pd_section() {
        // --- UG Reel Section Animation ---
        const reelSection = document.querySelector('.ug-reel-section');
        if (reelSection) {
            // 1. Video Player Logic
            const videoWrapper = reelSection.querySelector('.ug-reel-video-wrapper');
            const video = reelSection.querySelector('.ug-reel-video');
            const playButton = reelSection.querySelector('.ug-reel-play-button');
            const progressRing = reelSection.querySelector('.ug-reel-progress-ring-fg');

            if (video && playButton && progressRing) {
                const radius = progressRing.r.baseVal.value;
                const circumference = 2 * Math.PI * radius;
                progressRing.style.strokeDasharray = `${circumference} ${circumference}`;
                progressRing.style.strokeDashoffset = circumference;

                const setProgress = (percent) => {
                    const offset = circumference - (percent / 100 * circumference);
                    progressRing.style.strokeDashoffset = offset;
                }

                playButton.addEventListener('click', (e) => {
                    e.stopPropagation();
                    video.paused ? video.play() : video.pause();
                });

                video.addEventListener('play', () => playButton.classList.add('playing'));
                video.addEventListener('pause', () => {
                    playButton.classList.remove('playing');
                });
                video.addEventListener('timeupdate', () => {
                    const progress = (video.currentTime / video.duration) * 100;
                    setProgress(progress);
                });

                video.addEventListener('ended', () => {
                    setProgress(0);
                    playButton.classList.remove('playing');
                });

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (video.ended) video.currentTime = 0;
                            video.play();
                        } else {
                            video.pause();
                        }
                    });
                }, { threshold: 0.5 });
                observer.observe(videoWrapper);
            }
            // 2. GSAP 卡屏动画重写
            const videoPanel = reelSection.querySelector('.ug-reel-panel--video');
            const featurePanel = reelSection.querySelector('.ug-reel-panel--feature');
            // 只在手机端生效
            if (getViewportWidth() > 768) {
                if (videoPanel && featurePanel) {
                    // 只用 featurePanel 的高度撑 section
                    function setSectionToFeatureHeight() {
                        videoPanel.style.position = '';
                        featurePanel.style.position = '';
                        videoPanel.style.top = '';
                        videoPanel.style.left = '';
                        videoPanel.style.width = '';
                        videoPanel.style.zIndex = '';
                        featurePanel.style.zIndex = '';
                        // 只用 featurePanel 高度
                        reelSection.style.height = featurePanel.offsetHeight + 'px';
                        // 恢复定位
                        videoPanel.style.position = 'absolute';
                        videoPanel.style.top = '0';
                        videoPanel.style.left = '0';
                        videoPanel.style.width = '100%';
                        videoPanel.style.zIndex = '1';
                        featurePanel.style.position = 'relative';
                        featurePanel.style.zIndex = '2';
                    }
                    setSectionToFeatureHeight();
                    window.addEventListener('resize', setSectionToFeatureHeight);

                    gsap.set(featurePanel, { yPercent: 100 });
                    gsap.set(videoPanel, { filter: 'brightness(1)' });

                    function getPinEnd() {
                        return '+=' + videoPanel.offsetHeight;
                    }

                }
                gsap.timeline({
                    scrollTrigger: {
                        trigger: reelSection,
                        start: 'top top',
                        end: getPinEnd,
                        scrub: true,
                        pin: true,
                        anticipatePin: 1,
                        onRefresh: setSectionToFeatureHeight,
                        // markers: true, // 调试用
                    }
                })
                    .to(featurePanel, { yPercent: 0, ease: 'none' }, 0.3)
                    .to(videoPanel, { filter: 'brightness(0.5)', ease: 'none' }, 0)
                    .to(videoPanel, { opacity: 0, ease: 'none' }, 0.7);
            } else {
                document.querySelectorAll('.ug-reel-panel').forEach(panel => {
                    const mediaContent = panel.querySelector('.ug-reel-media-content');
                    if (!mediaContent) return;
                    const slides = Array.from(mediaContent.querySelectorAll('.ug-reel-media-slide'));
                    if (slides.length < 2) return;

                    // 吸顶卡屏
                    ScrollTrigger.create({
                        trigger: panel,
                        start: "top top",
                        end: () => `+=${panel.offsetHeight - window.innerHeight}`,
                        // pin: true,
                        pinSpacing: false,
                        anticipatePin: 1,
                        scrub: false,
                    });

                    // 初始化首屏可见
                    slides.forEach((slide, idx) => {
                        if (idx === 0) {
                            gsap.set(slide, { opacity: 1, y: 0 });
                            slide.classList.add('active');
                        } else {
                            gsap.set(slide, { opacity: 0, y: "100%" });
                            slide.classList.remove('active');
                        }
                    });

                    // 线性滚动驱动切换
                    const totalScroll = panel.offsetHeight - window.innerHeight;
                    ScrollTrigger.create({
                        trigger: panel,
                        start: "top top",
                        end: () => `+=${totalScroll}`,
                        scrub: true,
                        onUpdate: self => {
                            const progress = self.progress;
                            const seg = 1 / (slides.length - 1);
                            let idx = Math.floor(progress / seg);
                            idx = Math.max(0, Math.min(idx, slides.length - 2));
                            const localProg = (progress - seg * idx) / seg;

                            slides.forEach((slide, i) => {
                                if (i === idx) {
                                    // 当前slide上移
                                    gsap.to(slide, {
                                        y: 0 * localProg + "%",
                                        opacity: 1 - localProg,
                                        duration: 0.5,
                                        overwrite: true
                                    });
                                    slide.classList.add('active');
                                } else if (i === idx + 1) {
                                    // 下一个slide从下方滑入
                                    gsap.to(slide, {
                                        y: 100 - 100 * localProg + "%",
                                        opacity: localProg,
                                        duration: 0.5,
                                        overwrite: true
                                    });
                                    slide.classList.add('active');
                                } else {
                                    gsap.to(slide, {
                                        y: i < idx ? "-100%" : "100%",
                                        opacity: 0,
                                        duration: 0.5,
                                        overwrite: true
                                    });
                                    slide.classList.remove('active');
                                }
                            });
                        }
                    });
                });
            }

        }

    }
    function superfast() {
        // Super Fast Charging 横向卡屏切换 GSAP动效
        if (window.gsap && window.ScrollTrigger) {
            const slides = gsap.utils.toArray('.ug-superfast-slide');
            slides.forEach((slide, i) => {
                gsap.set(slide, { clipPath: i === 0 ? 'inset(0 0 0 0)' : 'inset(0 0 0 100%)' });
                slide.classList.toggle('is-active', i === 0);
            });
            ScrollTrigger.create({
                trigger: '.ug-superfast-section',
                start: 'top top',
                end: `+=${slides.length * window.innerHeight}`,
                pin: true,
                scrub: 1,
                onUpdate: self => {
                    const progress = self.progress * (slides.length - 1);
                    const idx = Math.floor(progress);
                    const percent = progress - idx;
                    slides.forEach((slide, i) => {
                        if (i < idx) {
                            gsap.set(slide, { clipPath: 'inset(0 0 0 0)' });
                            slide.classList.remove('is-active');
                        } else if (i === idx + 1) {
                            const right = (1 - percent) * 100;
                            gsap.set(slide, { clipPath: `inset(0 0 0 ${right}%)` });
                            slide.classList.add('is-active');
                        } else if (i === idx) {
                            gsap.set(slide, { clipPath: 'inset(0 0 0 0)' });
                            slide.classList.add('is-active');
                        } else {
                            gsap.set(slide, { clipPath: 'inset(0 0 0 100%)' });
                            slide.classList.remove('is-active');
                        }
                    });
                }
            });
        }
    }
    function parallax() {
        const cards = document.querySelectorAll('.ug-parallax-swiper-card');
        const defaultIndex = Math.floor(cards.length / 2); // 居中卡片索引

        function setCardState(activeIdx) {
            cards.forEach((c, i) => {
                if (i === activeIdx) {
                    c.classList.add('active');
                    gsap.to(c, {
                        width: "66%",
                        duration: 0.4,
                        ease: 'power2.out'
                    });
                } else {
                    c.classList.remove('active');
                    gsap.to(c, {
                        width: "17%",
                        duration: 0.4,
                        ease: 'power2.out'
                    });
                }
            });
        }

        // 初始化：中间卡片展开
        setCardState(defaultIndex);

        cards.forEach((card, idx) => {
            card.addEventListener('mouseenter', () => setCardState(idx));
            card.addEventListener('mouseleave', () => setCardState(defaultIndex));
        });
       const swiperInstance = new Swiper('.ug-parallax-swiper-section .ug-parallax-swiper', {
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 12,
            allowTouchMove: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 600,
            grabCursor: true,
        });
    }
    pageBanner();
    navBar();
    retractable_video();
    nexodelineupSwiperFn();
    features();
    sequence();
    pd_section();
    superfast();
    parallax();
});
